class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// Agregar el enlace de cotización cuando no hay resultados de búsqueda
document.addEventListener("DOMContentLoaded", function() {
  const searchResultsContainer = document.querySelector('[data-search-results]');
  const noResultsMessage = document.querySelector('.search-no-results');

  if (searchResultsContainer && noResultsMessage && searchResultsContainer.children.length === 0) {
    const cotizadorLink = document.createElement('a');
    cotizadorLink.href = 'https://ulloamotors.cl/pages/cotizador'; // Reemplaza con la URL de tu página de cotización
    cotizadorLink.textContent = 'Si no encuentras tu producto, cotiza aquí';
    cotizadorLink.classList.add('button'); // Añade una clase para estilos

    noResultsMessage.appendChild(document.createElement('br')); // Opcional: Agrega un salto de línea
    noResultsMessage.appendChild(cotizadorLink);
  }
});